
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/articles/[slug]",
      function () {
        return require("private-next-pages/en/articles/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/articles/[slug]"])
      });
    }
  